module.exports = "<mdl-spinner single-color active class='spinner' [hidden]='!loading'></mdl-spinner>\n";